module.exports = __webpack_public_path__ + "static/media/phone.60449d36.svg";